import script from "./TicketsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsView.vue?vue&type=script&setup=true&lang=js"

import "./TicketsView.vue?vue&type=style&index=0&id=f355c84a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f355c84a"]])

export default __exports__